import * as i0 from '@angular/core';
import * as i1 from './carousel.module';
import * as i2 from '@angular/common';
import * as i3 from './slide.component';
import * as i4 from './carousel.component';
export const CarouselModuleNgFactory:i0.NgModuleFactory<i1.CarouselModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.SlideComponent = (<any>(null as any));
var _decl0_12:i4.CarouselComponent = (<any>(null as any));
var _decl0_13:i2.AsyncPipe = (<any>(null as any));
var _decl0_14:i2.UpperCasePipe = (<any>(null as any));
var _decl0_15:i2.LowerCasePipe = (<any>(null as any));
var _decl0_16:i2.JsonPipe = (<any>(null as any));
var _decl0_17:i2.SlicePipe = (<any>(null as any));
var _decl0_18:i2.DecimalPipe = (<any>(null as any));
var _decl0_19:i2.PercentPipe = (<any>(null as any));
var _decl0_20:i2.TitleCasePipe = (<any>(null as any));
var _decl0_21:i2.CurrencyPipe = (<any>(null as any));
var _decl0_22:i2.DatePipe = (<any>(null as any));
var _decl0_23:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_24:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_25:i2.CommonModule = (<any>(null as any));
var _decl0_26:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_27:i0.ElementRef<any> = (<any>(null as any));
function _View_SlideComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_11.active;
  currVal_0;
  const currVal_1:any = _decl0_11.active;
  currVal_1;
  const currVal_2:any = _decl0_11.addClass;
  currVal_2;
  const currVal_3:any = _decl0_11.addClass;
  currVal_3;
}
function _View_SlideComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_11.active;
  currVal_0;
}
function _View_CarouselComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_CarouselComponent_2_2():void {
  if ((_decl0_12.showIndicators && (_decl0_12.slides.length > 1))) {
    var _any:any = (null as any);
    const currVal_0:any = (_any.active === true);
    currVal_0;
    const pd_1:any = ((<any>_decl0_12.selectSlide(_any)) !== false);
  }
}
function _View_CarouselComponent_2_1():void {
  if ((_decl0_12.showIndicators && (_decl0_12.slides.length > 1))) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_12.slides;
    currVal_0;
  }
}
function _View_CarouselComponent_2_4():void {
  if (((_decl0_12.slides.length > 1) && _decl0_12.isBs4)) { var _any:any = (null as any); }
}
function _View_CarouselComponent_2_3():void {
  if ((_decl0_12.slides.length > 1)) {
    var _any:any = (null as any);
    const currVal_0:any = ((_decl0_12.activeSlide === 0) && _decl0_12.noWrap);
    currVal_0;
    const currVal_1:any = _decl0_12.isBs4;
    currVal_1;
    const pd_2:any = ((<any>_decl0_12.previousSlide()) !== false);
  }
}
function _View_CarouselComponent_2_5():void {
  if ((_decl0_12.slides.length > 1)) {
    var _any:any = (null as any);
    const currVal_0:any = (_decl0_12.isLast(_decl0_12.activeSlide) && _decl0_12.noWrap);
    currVal_0;
    const pd_1:any = ((<any>_decl0_12.nextSlide()) !== false);
  }
}
function _View_CarouselComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_12.showIndicators && (_decl0_12.slides.length > 1));
  currVal_0;
  const currVal_1:any = (_decl0_12.slides.length > 1);
  currVal_1;
  const currVal_2:any = (_decl0_12.slides.length > 1);
  currVal_2;
  const pd_3:any = ((<any>_decl0_12.pause()) !== false);
  const pd_4:any = ((<any>_decl0_12.play()) !== false);
  const pd_5:any = ((<any>_decl0_12.play()) !== false);
}
